import React, { useMemo, useState, useEffect, useRef } from 'react';
import {EuiFlexGroup,EuiFlexItem, EuiFormRow, EuiFieldText, EuiButton, EuiSpacer, EuiCheckbox,EuiFilterGroup,EuiFilterButton,EuiSwitch, EuiAccordion, EuiButtonIcon, EuiPanel, EuiOverlayMask, EuiTitle, EuiPopover} from '@elastic/eui';
import ComboEmpleadosContainer from '../../../components/Combos/Empleados/container';
import {ComboProvinciasContainer as ComboProvincias} from '../../../components/Combos/Provincias/container';
import {ComboAreasContainer as ComboAreas} from '../../../components/Combos/Areas/container';
import {ComboPerfilesContainer as ComboPerfiles} from '../../../components/Selectores/Perfiles/container';
import {ComboDireccionesNegocioContainer as ComboDirecciones} from '../../../components/Combos/DireccionesNegocio/container';
import {ComboResponsablesAreaContainer as ComboresponsablesArea} from '../../../components/Combos/ResponsablesArea/container';
import {ComboSociedadesOriginalesContainer as ComboSociedadesOriginales} from '../../../components/Selectores/SociedadesOriginales/container';
import SelectorFecha from '../../../../../shared/components/Combos/Fecha';
import { CreateFechaMoment, ToSQL } from '../../../../../shared/utils/fecha';
import { PERFIL_ADMIN } from '../../../../../shared/constanst/constants';
import './styles.css';
import { ConfiguracionRolExpatriaciones } from './configuracionRolExpatriaciones';


const includesCTU = ['RAR','USR'];

const DnPermissions = (permissions) =>{
  return  permissions!==undefined ? [...new Set(permissions.map((f)=> f.idDN))] : permissions;
}

const AreasPermissions = (user,permissions, idDN) =>{
  return  (permissions!==undefined ? permissions.filter((f)=> f.idDN === idDN).map((m)=> m.codArea) : permissions);
}

export const Formulario = (props)=>{
  
  let {onSave, permisosUser, currentUser, selected, onClose, translate} = props
  
  let [dni,setDni] = useState(selected ? selected.dni : undefined)
  let [nombre, setNombre] = useState(selected ? selected.nombre : undefined)
  let [idDN, setIdDN] = useState(selected ? selected.idDN : (currentUser.perfil===PERFIL_ADMIN?undefined:currentUser.idDN))
  let [area, setArea] = useState((selected && selected.codArea!==null) ? selected.codArea : undefined)
  let [perfil, setPerfil] = useState(selected ? selected.perfil : undefined)
  let [login, setLogin] = useState(selected ? selected.login : undefined)
  let [email, setEmail] = useState(selected ? selected.email : undefined)
  let [cp, setCP] = useState(selected ? selected.idCP : undefined)
  let [fechaBaja, setFechaBaja] = useState(selected ? (selected.fechaBaja!==null?CreateFechaMoment(selected.fechaBaja):null) : null)
  let [responsable, setResponsable] = useState(selected ? selected.responsable : undefined)
  let [controlUsuarios, setControlUsuarios] = useState(selected ? selected.controlUsuarios : false)
  let [tipo, setTipo] = useState(selected ? selected.tipo : undefined)
  let [masCincuentaPorc, setMasCincuentaPorc] = useState(selected ? selected.masCincuentaPorc : false)
  let [sociedadOriginal, setSociedadOriginal] = useState(selected ? selected.idSociedadOriginal : undefined)
  let [administraUsuarios, setAdministraUsuarios] = useState(selected ? selected.administraUsuarios : false)
  let [empleado, setEmpleado] = useState([])
  let [provincia, setProvincia] = useState(selected ? selected.idProvincia : undefined)
  let [admExpatriados, setAdmExpatriados] = useState(selected ? selected.administraExpatriados : false)
  let [admExpatriadosLocal, setAdmExpatriadosLocal] = useState(selected ? selected.administraExpatriadosLocal : false)
  let [consultaExpatriados, setConsultaExpatriados] = useState(selected ? selected.consultaExpatriados : false)
  let [configuracionRolAdm, setConfiguracionRolAdm] = useState(null)
  let [configuracionRolAdmLocal, setConfiguracionRolAdmLocal] = useState(null)
  let [configuracionRolConsulta, setConfiguracionRolConsulta] = useState(null)
  let [partesConObra, setPartesConObra] = useState(selected ? selected.partesConObra : false)

  const _tipos = [{label:translate('estructura'),value:'E'}, {label:translate('obra'),value:'O'}];
  
  useEffect(()=>{
    if(empleado.length>0){
      setDni(empleado[0].value.documentoIdentidad)
      setNombre(empleado[0].value.apellidosNombre)
      setEmail(empleado[0].value.email)
      setIdDN(empleado[0].value.direccion!==null?empleado[0].value.direccion.split('-')[0].trim():undefined)
      setFechaBaja(empleado[0].value.fechaBaja!==null?CreateFechaMoment(empleado[0].value.fechaBaja):null)
      setCP(empleado[0].value.centroCoste!==null?empleado[0].value.centroCoste.split('-')[0].trim():undefined)
      setLogin(empleado[0].value.usuario)
      setProvincia(empleado[0].value.provinciaCotizacion)
    }else{
      if(selected===undefined){
        setDni('')
        setNombre('')
        setEmail('')
        setIdDN(undefined)
        setFechaBaja(null)
        setCP('')
        setLogin('')
        setProvincia(undefined)
      }
    }
  },[empleado])

  const getIdEmpleado = useMemo(() =>{
    if(selected!==undefined){
      return selected.idEmpleado
    }else{
      return empleado.length>0 ? empleado[0].value.idEmpleado : null
    }
  },[selected,empleado])

  const getData = () =>{
    return {
      dni: dni,
      nombre: nombre,
      idDN: (Array.isArray(idDN) ? idDN[0].value : idDN),
      codArea: isInvalidArea ? null : (Array.isArray(area) ? area[0].value : area),
      perfil:perfil,
      login: login,
      email: email,
      idCP: cp,
      fechaBaja: (fechaBaja!==null ? ToSQL(fechaBaja,'-') : fechaBaja),
      responsable: ((Array.isArray(responsable)&&responsable.length>0) ? responsable[0].value : null),
      controlUsuarios: controlUsuarios,
      tipo: tipo,
      masCincuentaPorc: masCincuentaPorc,
      idSociedadOriginal: sociedadOriginal,
      administraUsuarios: administraUsuarios,
      administraExpatriados: admExpatriados,
      administraExpatriadosLocal: admExpatriadosLocal,
      consultaExpatriados: consultaExpatriados,
      idEmpleado: getIdEmpleado,
      idProvincia: (Array.isArray(provincia) ? provincia[0].value : provincia),
      partesConObra: partesConObra
    }
  }

  //const getDNSelection = useMemo(()=>(idDN!==undefined && (Array.isArray(idDN) ? (idDN.length>0 ? idDN[0].value : undefined) : idDN)),[idDN])

  const onSaveData = () =>{
    if(!comprobarErrores()){
      let newData = getData();
      let configAdm = admExpatriados?configuracionRolAdm:{rol:'AD',sociedades:''}
      let confiGAdmLocal = admExpatriadosLocal?configuracionRolAdmLocal:{rol:'ADL',sociedades:''}
      let configConsulta = consultaExpatriados?configuracionRolConsulta:{rol:'CON',sociedades:''}
      let configuracionRoles = [configAdm, confiGAdmLocal, configConsulta].filter((f)=> f!==null)

      onSave && onSave(newData,configuracionRoles)
    }
  }

  const comprobarErrores = () => {
    return isInvalidDni || isInvalidNombre || isInvalidCP || isInvalidDN || isInvalidPerfil || isInvalidProvincia
  }

  const isInvalidDni = useMemo(() => dni === undefined || dni.trim() === "",[dni])
  const isInvalidNombre = useMemo(() => nombre === undefined || nombre.trim() === "",[nombre])
  const isInvalidArea = useMemo(() => area === undefined || area === null || area.length === 0,[area])
  const isInvalidPerfil = useMemo(() => perfil === undefined,[perfil])
  const isInvalidLogin = useMemo(() => login === undefined || login === null || login.trim() === "",[login])
  const isInvalidEmail = useMemo(() => email === undefined || email === null || email.trim() === "",[email])
  const isInvalidDN = useMemo(() => idDN === undefined || idDN === null || idDN.length === 0,[idDN])
  const isInvalidCP = useMemo(() => cp === undefined || cp===null || cp.trim() === "",[cp])
  const isInvalidProvincia = useMemo(() => provincia === undefined || provincia===null || provincia.length === 0,[provincia])

  const isDisabledDN = useMemo(()=> {
  const dnEmpleado = empleado.length>0 ? (empleado[0].value.direccion!==null?empleado[0].value.direccion.split('-')[0].trim():'') : '';
  return  idDN && (idDN.length>0 && idDN[0].value === dnEmpleado)
  }
  ,[idDN, empleado])

  const getChkAdministradorExpatriados = useMemo(()=>(
    <EuiFlexGroup alignItems='center' justifyContent='spaceAround'>
      <EuiSwitch id='chk-admExpatriados' label='' checked={admExpatriados} onChange={(e)=>setAdmExpatriados(!admExpatriados)}/>
      <ConfiguracionRolExpatriaciones disabled={!admExpatriados} user={selected?selected:{dni:dni, nombre: nombre}} 
      rol={{value:'AD',label:'Administrador Expatriados'}} handleSave={setConfiguracionRolAdm}/>
    </EuiFlexGroup>
  ),[admExpatriados, setAdmExpatriados,setConfiguracionRolAdm])

  const getChkAdministradorExpatriadosLocal = useMemo(()=>(
    <EuiFlexGroup alignItems='center' justifyContent='spaceAround'>
      <EuiSwitch id='chk-admExpatriadosLocal' label='' checked={admExpatriadosLocal} onChange={(e)=>setAdmExpatriadosLocal(!admExpatriadosLocal)}/>
      <ConfiguracionRolExpatriaciones disabled={!admExpatriadosLocal} user={selected?selected:{dni:dni, nombre: nombre}} 
      rol={{value:'ADL',label:'Administrador Expatriados Local'}} handleSave={setConfiguracionRolAdmLocal}/>
    </EuiFlexGroup>
  ),[admExpatriadosLocal, setAdmExpatriadosLocal, setConfiguracionRolAdmLocal])

  const getChkConsultaExpatriados = useMemo(()=>(
    <EuiFlexGroup alignItems='center' justifyContent='spaceAround'>
      <EuiSwitch id='chk-consultaExpatriados' label='' checked={consultaExpatriados} onChange={(e)=>setConsultaExpatriados(!consultaExpatriados)}/>
      <ConfiguracionRolExpatriaciones disabled={!consultaExpatriados} user={selected?selected:{dni:dni, nombre: nombre}} 
      rol={{value:'CON',label:'Consulta Expatriados'}} handleSave={setConfiguracionRolConsulta}/>
    </EuiFlexGroup>
  ),[consultaExpatriados, setConsultaExpatriados, setConfiguracionRolConsulta])

  const isDisabledParteObra = useMemo(()=> currentUser && (currentUser.login!=='svadillo' && currentUser.login!=='certifica'),[currentUser])

  const getPanelConfigExpatriados = ()=>(currentUser && currentUser.perfil===PERFIL_ADMIN)?(
      <EuiFlexItem grow={false}>
        <EuiFlexGroup>
          <EuiFlexItem grow={false} className='chk-mascincuentaporc'>
            <EuiFormRow fullWidth label={translate('administra-expatriados-abreviado')}>
                {getChkAdministradorExpatriados}
            </EuiFormRow>
          </EuiFlexItem>
          <EuiFlexItem grow={false} className='chk-mascincuentaporc'>
            <EuiFormRow fullWidth label={translate('administra-expatriados-local-abreviado')}>
                {getChkAdministradorExpatriadosLocal}
            </EuiFormRow>
          </EuiFlexItem>
          <EuiFlexItem grow={false} className='chk-mascincuentaporc'>
            <EuiFormRow fullWidth label={translate('consulta-expatriados')}>
              {getChkConsultaExpatriados}
            </EuiFormRow>
          </EuiFlexItem>
        </EuiFlexGroup>
    </EuiFlexItem>
  ):null

  const getusuariosPanel = ()=>(
    <EuiFlexGroup direction='column'>
      {selected===undefined ?
        <EuiFlexItem>
          <EuiFlexGroup>
            <EuiFlexItem>
                <EuiFormRow fullWidth label={translate("empleados")}>
                <ComboEmpleadosContainer fullWidth selectedOptions={empleado} dnFilters={DnPermissions(permisosUser)} onChange={value => {setEmpleado(value)}}/>
                </EuiFormRow>
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlexItem>
        :null}

        <EuiFlexItem>
          <EuiFlexGroup>
            <EuiFlexItem grow={4}>
                <EuiFormRow fullWidth label={translate("dni")} isInvalid={isInvalidDni}>
                  <EuiFieldText fullWidth value={dni} name="txtDni" onChange={e => setDni(e.target.value)} isInvalid={isInvalidDni}/>
                </EuiFormRow>
            </EuiFlexItem>
            <EuiFlexItem grow={6}>
                <EuiFormRow fullWidth label={translate("nombre")} isInvalid={isInvalidNombre}>
                  <EuiFieldText fullWidth value={nombre} name="txtNombre" onChange={e => setNombre(e.target.value)} isInvalid={isInvalidNombre}/>
                </EuiFormRow>
            </EuiFlexItem>
            <EuiFlexItem grow={4}>
              <EuiFormRow fullWidth label={translate("provincia")} isInvalid={isInvalidProvincia}>
                <ComboProvincias fullWidth selectedOptions={provincia} onChange={value => {setProvincia(value); }} isInvalid={isInvalidProvincia}/>
                </EuiFormRow>
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlexItem>

        <EuiFlexItem>
          <EuiFlexGroup>
            <EuiFlexItem>
                <EuiFormRow fullWidth label="Email">
                  <EuiFieldText fullWidth value={email} name="txtEmail" onChange={e => setEmail(e.target.value)}/>
                </EuiFormRow>
            </EuiFlexItem>
            <EuiFlexItem>
                <EuiFormRow fullWidth label={translate("fecha-de-baja")}>
                  <SelectorFecha fullWidth selected={fechaBaja} popoverPlacement="left" onChange={date => setFechaBaja(date)} onClear={() => setFechaBaja(null)}/>
                </EuiFormRow>
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
                <EuiFormRow label={translate("centro-produccion")} isInvalid={isInvalidCP}>
                  <EuiFieldText maxLength={3} fullWidth value={cp} name="txtCP" onChange={e => setCP(e.target.value.toUpperCase())} isInvalid={isInvalidCP}/>
                </EuiFormRow>
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlexItem>

        <EuiFlexItem>
          <EuiFlexGroup>
            <EuiFlexItem>
              <EuiFormRow fullWidth label={translate('direccion-de-negocio')} isInvalid={isInvalidDN}>
                <ComboDirecciones fullWidth selectedOptions={idDN} dnFilters={DnPermissions(permisosUser)} onChange={value => {setIdDN(value); }} 
                isInvalid={isInvalidDN} isDisabled={isDisabledDN}/>
              </EuiFormRow>
            </EuiFlexItem>
            <EuiFlexItem>
              <EuiFormRow fullWidth label={translate("area")}>
                <ComboAreas fullWidth selectedOptions={area} onChange={value => setArea(value)}
                    idDN={!isInvalidDN ? (Array.isArray(idDN) ? idDN[0].value : idDN) : undefined} 
                    areasFilter={!isInvalidDN ? AreasPermissions(currentUser,permisosUser, (Array.isArray(idDN) ? idDN[0].value : idDN)) : undefined}
                    isDisabled={(isInvalidDN)} dependency/>
              </EuiFormRow>
            </EuiFlexItem>
            </EuiFlexGroup>
        </EuiFlexItem>

        <EuiFlexItem>
          <EuiFlexGroup>
            <EuiFlexItem grow={false}>
                <EuiFormRow fullWidth label={translate("perfil")} isInvalid={isInvalidPerfil}>
                  <ComboPerfiles fullWidth valueOfSelected={perfil} onChange={value => setPerfil(value)} isInvalid={isInvalidPerfil}
                  currentUser={currentUser}
                  append={<EuiFlexItem grow={false} className={`chkPerfilUser ${(!includesCTU.includes(perfil)) ? 'disabled': (!controlUsuarios?'no-active':'active')}`}>
                    <EuiCheckbox id='chk-ctu' label='CTU' checked={controlUsuarios} onChange={(e)=>setControlUsuarios(!controlUsuarios)} disabled={!includesCTU.includes(perfil)}/>
                    </EuiFlexItem>}
                  />
                </EuiFormRow>
              </EuiFlexItem>

            <EuiFlexItem grow={false}>
                <EuiFormRow fullWidth label={translate("usuario")}>
                  <EuiFieldText fullWidth value={login} name="txtLogin" onChange={e => setLogin(e.target.value)}/>
                </EuiFormRow>
            </EuiFlexItem>
            <EuiFlexItem>
                <EuiFormRow fullWidth label={translate("sociedad-original")}>
                  <ComboSociedadesOriginales fullWidth valueOfSelected={sociedadOriginal} onChange={value => setSociedadOriginal(value)}/>
                </EuiFormRow>
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlexItem>

        <EuiFlexItem>
          <EuiFlexGroup>
            <EuiFlexItem>
              <EuiFormRow fullWidth label={translate("responsable")}>
                <ComboresponsablesArea fullWidth selectedOptions={responsable} onChange={value => setResponsable(value)}/>
              </EuiFormRow>
            </EuiFlexItem>
            <EuiFlexItem>
              <EuiFormRow fullWidth hasEmptyLabelSpace>
                <EuiFilterGroup fullWidth>
                  <EuiFilterButton
                    hasActiveFilters={tipo===_tipos[0].value}
                    onClick={()=>setTipo(_tipos[0].value)}>
                    {_tipos[0].label}
                  </EuiFilterButton>
                  <EuiFilterButton
                    hasActiveFilters={tipo===_tipos[1].value}
                    onClick={()=>setTipo(_tipos[1].value)}>
                      {_tipos[1].label}
                  </EuiFilterButton>
                </EuiFilterGroup>
              </EuiFormRow>
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlexItem>

        <EuiFlexItem>
          <EuiFlexGroup>
            <EuiFlexItem className='panelSwitchUserForm'>
              <EuiFlexGroup justifyContent='spaceBetween'>
                <EuiFlexItem>
                  <EuiFlexGroup>
                      <EuiFlexItem grow={false} className='chk-mascincuentaporc'>
                        <EuiFormRow fullWidth label={translate("administra-usuarios")}>
                        <EuiSwitch id='chk-admusuarios' label='' checked={administraUsuarios} onChange={(e)=>setAdministraUsuarios(!administraUsuarios)}/>
                        </EuiFormRow>
                      </EuiFlexItem>
                       <EuiFlexItem grow={false} className='chk-mascincuentaporc'>
                        <EuiFormRow fullWidth label={"Parte/Obra"}>
                        <EuiSwitch disabled={isDisabledParteObra} id='chk-parteobra' label='' checked={partesConObra} onChange={(e)=>setPartesConObra(!partesConObra)}/>
                        </EuiFormRow>
                      </EuiFlexItem>
                  </EuiFlexGroup>
                </EuiFlexItem>
                {getPanelConfigExpatriados()}
              </EuiFlexGroup>
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlexItem>
    </EuiFlexGroup>
  )

  return (
    <>
      {getusuariosPanel()}
      <EuiSpacer size="l" />
      <EuiFlexGroup style={{position:'sticky', bottom:0, backgroundColor:'white'}}>
        <EuiFlexItem>
          <EuiButton onClick={onSaveData} disabled={comprobarErrores()}>
            {translate('guardar')}
          </EuiButton>
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiButton color="danger" onClick={()=>onClose()}>{translate('cancelar')}</EuiButton>
        </EuiFlexItem>
      </EuiFlexGroup>
    </>
  )
}
export default Formulario;